import {makeArrayFromLength} from 'oolib'
import { genHash } from '../utils/genHash';


const genNewRow = ({data, rowIdx, blockConfig}) => {
  let totCells = data[rowIdx].cellData.length;
  return ({
    id: `row_${genHash(8)}`,
    cellData: makeArrayFromLength(totCells).map((d, i) => ({
        id : `cell_${genHash(8)}`,
        // Apply blockConfig if provided, so new rows have the correct component type
        ...(blockConfig?.[i]?.comp ? { comp: blockConfig[i].comp } : {}),
        ...(blockConfig?.[i]?.props ? { props: blockConfig[i].props } : {}),
      }))
  })
}

export const handleAddRow = (value, props) => {
    const { onChange, id, config } = props;
    const {data, colWidthConfig} = value;
    let newData = [...data];
    let lastRowIdx = newData.length-1;

    const newRow = genNewRow({data: newData, rowIdx: lastRowIdx, blockConfig: config?.blockConfig});

    newData.push(newRow);

    onChange && onChange(id, {data: newData, colWidthConfig});
}


export const handleDeleteRow = ({value, rowIdx, onChange, id}) => {
  const {data, colWidthConfig} = value;
  let newData = [...data];
  newData.splice(rowIdx, 1)
  onChange && onChange(id, {data: newData, colWidthConfig}); 
}

export const handleDuplicateRow = ({value, rowIdx, onChange, id}) => {
  const {data, colWidthConfig} = value;
  let newData = [...data];
  const dataToDuplicate = {
    ...newData[rowIdx],
    id: `row_${genHash(8)}`,
    cellData: newData[rowIdx].cellData.map(cell => ({
      ...cell,
      id : `cell_${genHash(8)}`,
    }))
  }
  newData.splice(rowIdx+1, 0, dataToDuplicate)
  onChange && onChange(id, {data: newData, colWidthConfig}); 
}

export const handleInsertRowAfter = ({value, rowIdx, onChange, id, blockConfig}) => {
  const {data, colWidthConfig} = value;
  let newData = [...data];

  const newRow = genNewRow({data: newData, rowIdx, blockConfig})

  newData.splice(rowIdx+1, 0, newRow)
  onChange && onChange(id, {data: newData, colWidthConfig});
}

export const handleInsertRowBefore = ({value, rowIdx, onChange, id, blockConfig}) => {
  const {data, colWidthConfig} = value;
  let newData = [...data];

  const newRow = genNewRow({data: newData, rowIdx, blockConfig})

  newData.splice(rowIdx, 0, newRow)
  onChange && onChange(id, {data: newData, colWidthConfig});
}

export const handleClearRowContent = ({value, rowIdx, onChange, id, blockConfig}) => {
  const {data, colWidthConfig} = value;
  let newData = [...data];

  /**
   * this genNewRow does one very important thing apart from the obvious of clearing the value:
   * it creates a fresh new row id, which changes the 'react key' of the row being rendered, which
   * ensures the the RTE used within the cell is reinitiated and the previous value in it is cleared.
   * (since RTEs are not controlled components)
   */
  const newRow = genNewRow({data: newData, rowIdx, blockConfig})

  newData.splice(rowIdx, 1, newRow)
  onChange && onChange(id, {data: newData, colWidthConfig});
}